"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _reactCsv = require("react-csv");

var _moreTableData = _interopRequireDefault(require("./moreTableData"));

var _utils = _interopRequireDefault(require("../../../../../utils"));

var header = [{
  label: "Date",
  key: "Date"
}, {
  label: "CL_code",
  key: "CL_code"
}, {
  label: "CR_code",
  key: "RM_code"
}, {
  label: "Active Student",
  key: "ActiveParents"
}, {
  label: "Dropout Student",
  key: "DropoutParent"
}, {
  label: "Response Rate",
  key: "Response_rate"
}, {
  label: "Forms Fill Next Day",
  key: "FormsFillNextDay"
}, {
  label: "Late in Training",
  key: "Late_in_Training"
}, {
  label: "Audit Marks",
  key: "Audit_marks"
}, {
  label: "What RM Does",
  key: "WhatRMDoes"
}, {
  label: "Rating",
  key: "Rating"
}];
var date = new Date();
var today = "".concat(date.getFullYear(), "-").concat(date.getMonth() + 1, "-").concat(date.getDate());
var time = "".concat(date.getHours(), ":").concat(date.getMinutes());

var TableData = function TableData(_ref) {
  var data = _ref.data;
  var csvRport = {
    filename: "Rating Data " + today + " " + time,
    headers: header,
    data: data
  };

  var _useState = (0, _react.useState)(data),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      tableData = _useState2[0],
      setTableData = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      Loading = _useState4[0],
      setLoading = _useState4[1]; // useEffect(async () => {
  //   data.map((obj, index) => {
  //     if (obj.index === undefined) obj.index = index;
  //   })
  //   setTableData(data);
  //   setLoading(false)
  // }, [data]);


  (0, _react.useEffect)(function () {
    function fetchData() {
      return _fetchData.apply(this, arguments);
    }

    function _fetchData() {
      _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data.forEach(function (obj, index) {
                  if (obj.index === undefined) obj.index = index;
                });
                setTableData(data);
                setLoading(false);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetchData.apply(this, arguments);
    }

    fetchData(); // eslint-disable-next-line 
  }, [data]);
  var columns = [{
    title: "Date",
    dataIndex: "Date",
    key: "Date",
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'Date');
    }
  }, {
    title: "CR Code",
    dataIndex: "RM_code",
    key: "RM_code",
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'RM_code');
    }
  }, {
    title: "Response Rate",
    dataIndex: "Response_rate",
    key: "",
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'Response_rate');
    }
  }, {
    title: "Audit Marks",
    dataIndex: "Audit_marks",
    key: "Audit_marks",
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'Audit_marks');
    }
  }, {
    title: "Rating",
    dataIndex: "Rating",
    key: "Rating",
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'Rating');
    }
  }];
  return Loading ? /*#__PURE__*/_react.default.createElement(_antd.Spin, {
    tip: "Loading..."
  }) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "History Of Rating",
    extra: /*#__PURE__*/_react.default.createElement(_reactCsv.CSVLink, csvRport, /*#__PURE__*/_react.default.createElement(_icons.DownloadOutlined, {
      style: {
        'fontSize': 30
      }
    }))
  }, /*#__PURE__*/_react.default.createElement(_antd.Table, {
    columns: columns,
    dataSource: tableData,
    rowKey: "index",
    expandable: {
      expandedRowRender: function expandedRowRender(record) {
        return /*#__PURE__*/_react.default.createElement(_moreTableData.default, {
          record: record
        });
      }
    }
  })));
};

var _default = TableData;
exports.default = _default;